import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sticky-notification" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "material-icons material-symbols-sharp" }, "info"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" We're in Open Alpha! Sign up and give Scrolldex"),
    /*#__PURE__*/_createElementVNode("sup", null, "™"),
    /*#__PURE__*/_createTextVNode(" a try for free. ")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "title is-1" }, [
  /*#__PURE__*/_createTextVNode("Business Cards, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" but digital")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, [
  /*#__PURE__*/_createTextVNode("Always have your business cards available with Scrolldex"),
  /*#__PURE__*/_createElementVNode("sup", null, "™")
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Get started ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title is-2" }, "What does it do?"),
  /*#__PURE__*/_createElementVNode("p", null, "It makes it easier to share your details while networking, by:")
], -1)
const _hoisted_8 = { class: "usp__icon" }
const _hoisted_9 = { class: "material-icons" }
const _hoisted_10 = { class: "title is-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title is-2" }, "How it works")
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Try it for free ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("footer", { class: "page-footer byline" }, " All rights reserved © Scrolldex 2022 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_slider = _resolveComponent("slider")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_logo),
      _createVNode(_component_router_link, {
        class: "button is-link",
        style: {"margin":"2rem auto auto"},
        to: "/sign-up"
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", null, [
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usps, (usp, key) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "usp",
          key: key
        }, [
          _createElementVNode("figure", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(usp.icon), 1)
          ]),
          _createElementVNode("h3", _hoisted_10, _toDisplayString(usp.title), 1),
          _createElementVNode("p", null, _toDisplayString(usp.body), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("section", null, [
      _hoisted_11,
      _createVNode(_component_slider)
    ]),
    _createElementVNode("section", null, [
      _createVNode(_component_router_link, {
        class: "button is-link",
        style: {"margin":"0 auto"},
        to: "/sign-up"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    _hoisted_13
  ]))
}